import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import {library} from '@fortawesome/fontawesome-svg-core'

import {Provider} from "react-redux"
import {createMuiTheme, ThemeProvider} from '@material-ui/core/styles';
import {
  faBars,
  faBox,
  faBoxOpen,
  faBriefcaseMedical,
  faCaretDown,
  faCaretLeft,
  faCaretRight,
  faCaretUp,
  faCheck,
  faCheckCircle,
  faCogs,
  faComments,
  faEnvelope,
  faExclamationCircle,
  faExclamationTriangle,
  faFileDownload,
  faFileUpload,
  faFolderOpen,
  faFolderPlus,
  faHome,
  faKey,
  faList,
  faLock,
  faLockOpen,
  faPlus,
  faQuestionCircle,
  faShieldAlt,
  faSignOutAlt,
  faTimes,
  faTrash,
  faUser,
  faUserCheck,
  faUserCog,
  faUserFriends,
  faUserLock,
  faUsers,
  faUserShield,
  faUserTie,
  faUserTimes,
  faHouseUser,
  faHospitalUser,
  faUserInjured, faEdit, faInfoCircle, faBan
} from '@fortawesome/free-solid-svg-icons';

import { fa } from '@fortawesome/free-regular-svg-icons'
import config from "./config/config";
import {Auth0Provider} from "./utils/providers/Auth0Provider";
import store from "./redux/store";
import Fidelius from "./components/Fidelius/Fidelius";
import {StripeProvider} from 'react-stripe-elements';

library.add(faCheck, faTimes, faQuestionCircle, faCheckCircle, faExclamationCircle, faEdit, faInfoCircle,
  faFolderPlus, faFileUpload, faKey, faLock, faBox, faBoxOpen, faLockOpen,
  faBriefcaseMedical, faUserShield, faFolderOpen, faHome, faShieldAlt, faCaretDown, faUserInjured,
  faCaretLeft, faCaretRight, faCaretUp, faUser, faUserLock, faUserFriends, faFileDownload, faHospitalUser,
  faUserCheck, faUserTimes, faTrash, faUserCog, faSignOutAlt, faBars, faCogs, faList, faEnvelope, faHouseUser,
  faPlus, faComments, faUsers, faUserTie, faExclamationTriangle, faUserTie, faBan);

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#02B085"
    },
    secondary: {
      main: "#3af",
      contrastText: '#ffffff',
    },
    error: {
      main: "#A54657",
      contrastText: '#ffffff',
    },
    warning: {
      main: "#fe8829",
      contrastText: '#ffffff',
    },
  },
  typography: {
    fontFamily: 'Montserrat, Arial',
  },
});

const onRedirectCallback = appState => {
  window.history.replaceState(
    {},
    document.title,
    appState && appState.targetUrl
      ? appState.targetUrl
      : window.location.pathname
  );
};


ReactDOM.render(
  <Auth0Provider
    domain={config.auth0_domain}
    client_id={config.auth0_clientId}
    audience={config.auth0_audience}
    redirect_uri={window.location.origin}
    scope={'openid email profile'}
    onRedirectCallback={onRedirectCallback}
  >
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <StripeProvider apiKey={config.stripe_key}>
          <Fidelius/>
        </StripeProvider>
      </Provider>
    </ThemeProvider>
  </Auth0Provider>
 ,
  document.getElementById('root'));
